function cov_1skdnlb5pg() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateFilled.tsx";
  var hash = "fc44ed0f0c9ed9975d1b15e5a2a562255a66e928";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fc44ed0f0c9ed9975d1b15e5a2a562255a66e928"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1skdnlb5pg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1skdnlb5pg();
var Icon = (cov_1skdnlb5pg().s[0]++, {
  name: 'date-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.75 3C8.75 2.30964 8.19036 1.75 7.5 1.75C6.80964 1.75 6.25 2.30964 6.25 3V5H5C3.34315 5 2 6.34315 2 8V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V8C22 6.34315 20.6569 5 19 5H17.75V3C17.75 2.30964 17.1904 1.75 16.5 1.75C15.8096 1.75 15.25 2.30964 15.25 3V5H8.75V3ZM3.75 12C3.75 11.3096 4.30964 10.75 5 10.75H19C19.6904 10.75 20.25 11.3096 20.25 12C20.25 12.6904 19.6904 13.25 19 13.25H5C4.30964 13.25 3.75 12.6904 3.75 12Z\" fill=\"currentColor\"/>"
});
export default Icon;